import styled, { css } from 'styled-components';
import Tokens from '@nokia-csf-uxr/freeform-design-tokens';
import { BORDER_BOX } from 'common';

const HEIGHT = '0.25rem';

export default {
  DeterminateContainer: styled.div`
    display: flex;
    align-items: center;
    ${({ rtl }) => rtl && css`
      direction: rtl;
    `}
  `,
  Wrapper: styled.div`
    width: 100%;
  `,
  ContentWrapper: styled.div`
    height: ${HEIGHT};
    ${({ $theme }) => css`background: ${$theme.track};`}
  `,
  ProgressIndicator: styled.div`
    height: ${HEIGHT};
    overflow: hidden;
  `,
  CloseButton: styled.div`
    ${({ rtl }) => rtl ? css`
      margin-right: ${Tokens.SPACING.SPACING_8};
    ` : css`
      margin-left: ${Tokens.SPACING.SPACING_8};
    `}
  `,
  ProgressBarText: styled.div`
    ${BORDER_BOX}
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    ${({ $theme }) => css`color: ${$theme.text};`}
    padding: ${Tokens.SPACING.SPACING_4} 0;
    ${Tokens.TYPOGRAPHY.CAPTION}
  `
};